import { Component, Input, inject, ChangeDetectionStrategy } from "@angular/core";
import { UntypedFormGroup } from "@angular/forms";
import { SaveButtonComponent } from "@components/save-button/save-button.component";
import { ModalComponentMediator } from "~app/common/components/modal/modal-component-mediator";
import { LeverantorsorderradCreateComponent } from "../leverantorsorderrad-create/leverantorsorderrad-create.component";

@Component({
    selector: "rask-create-leverantorsorderrad-modal",
    templateUrl: "./create-leverantorsorderrad-modal.component.html",
    styleUrls: ["./create-leverantorsorderrad-modal.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        LeverantorsorderradCreateComponent,
        SaveButtonComponent
    ]
})
export class CreateLeverantorsorderradModalComponent {
    form: UntypedFormGroup;
    model: any;
    order: any;
    orderradAdded: any;

    private readonly modalComponentMediator = inject(ModalComponentMediator);

    // eslint-disable-next-line @angular-eslint/no-input-rename
    @Input("data") set data(value) {
        this.order = value.order;
        this.orderradAdded = value.orderradAdded;
        this.form = value.rootForm;
    }

    abort() {
        this.close();
    }

    add() {
        if (this.canAdd()) {
            this.orderradAdded(this.model);
            this.close();
        }
    }

    canAdd() {
        const createForm = this.form.controls.levorder0;
        return createForm && !createForm.invalid;
    }

    close() {
        this.form.removeControl("levorder0");
        this.modalComponentMediator.getRef().close(null);
    }

    onModelCreated(model) {
        this.model = model;
    }
}
